import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';

import { showAlert } from '../../store/ducks/alert';
import { getTagIssue } from '../../services/tags';
import { CircularProgress } from '@material-ui/core';

const TagIssues = (props) => {
  const dispatch = useDispatch();
  const [tagIssue, setTagIssue] = useState([]);
  const [page, setPage] = useState(0);
  const [pageTitle, setPageTitle] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  
  useEffect(() => {
    displayTagIssues();
  }, []);

  const displayTagIssues = async () => {
    const tagSlug = props.match.params.slug;
    try {
      setIsLoading(true);
      const {data} = await getTagIssue(tagSlug);
      setPageTitle(tagSlug);
      setTagIssue(data.map((item) => { 
        return {
          title: item.title,
          uid: item.uid,
          slug: item.slug
        }
      }));
      setPage(data.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert("error", error.message));
      console.log(error);
    }
  };

  const headers = ['title', 'uid', 'slug'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Issues related to "{pageTitle}"</h1>

      </div>

      <DataTable
        useUid
        head={headers}
        body={tagIssue}
        action
        bodyColumn={headers}
        linkPath={'issues'}
        setPageChange={setPage}
        isNotOrdenable
      />
    </>
  );
};

export default TagIssues;
